import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./modules/home/home.component').then(mod => mod.HomeComponent),
        pathMatch: 'full'
    },
    {
        path: '1',
        loadComponent: () => import('./modules/forms-create-and-transform-pharmacy/forms-create-and-transform-pharmacy.component').then(mod => mod.FormsCreateAndTransformPharmacyComponent),
        pathMatch: `full`
    },
    {
        path: '2',
        loadComponent: () => import('./modules/internal-referral-form/internal-referral-form.component').then(mod => mod.InternalReferralFormComponent),
        pathMatch: 'full'
    },
    {
        path: '3',
        loadComponent: () => import('./modules/forms-register/pages/forms-register/forms-register.component').then(mod => mod.FormsRegisterComponent),
        pathMatch: 'full'
    },
    {
        path: '4',
        loadComponent: () => import('./modules/forms-create-and-transform-pharmacy-copy/forms-create-and-transform-pharmacy-copy.component').then(mod => mod.FormsCreateAndTransformPharmacyComponent),
        pathMatch: 'full'
    },
    {
        path: '5',
        loadComponent: () => import('./modules/forms-register/pages/forms-register/forms-register.component').then(mod => mod.FormsRegisterComponent),
        pathMatch: 'full'
    },
    {
        path: '7',
        loadComponent: () => import('./modules/lead-forms/lead-forms.component').then(mod => mod.LeadFormsComponent),
        pathMatch: 'full'
    },
    {
        path: '8',
        loadComponent: () => import('./modules/forms-create-and-transform-pharmacy-copy-2/forms-create-and-transform-pharmacy-copy.component').then(mod => mod.FormsCreateAndTransformPharmacyComponent),
        pathMatch: 'full'
    },
    {
        path: '9',
        loadComponent: () => import('./modules/forms-lead-capture/pages/forms-lead-capture/forms-lead-capture.component').then(mod => mod.FormsLeadCaptureComponent),
        pathMatch: 'full'
    },
    {
        path: '10',
      loadComponent: () => import('./modules/forms-lp-afiliados/forms-lp-afiliados.component').then((mod => mod.FormsLpFiliadosComponent)),
      pathMatch: 'full'
    },
    {
        path: '11',
        loadComponent: () => import('./modules/forms-contact/pages/forms-contact.component').then(mod => mod.FormsContactComponent),
        pathMatch: 'full'
    },
];
